import React from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const handleNavClick = (path) => {
    if (!isHomePage) {
      navigate("/", { state: { scrollTo: path } });
    }
  };

  const renderNavLink = (name, path) => {
    if (isHomePage) {
      return (
        <ScrollLink
          to={path}
          smooth={true}
          duration={300}
          offset={-60}
          className="text-gray-400 hover:text-white transition cursor-pointer"
        >
          {name}
        </ScrollLink>
      );
    }

    return (
      <button
        onClick={() => handleNavClick(path)}
        className="text-gray-400 hover:text-white transition"
      >
        {name}
      </button>
    );
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Impact Logistics</h3>
            <p className="text-gray-400">
              Transforming logistics through innovative solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>{renderNavLink("Home", "hero")}</li>
              <li>{renderNavLink("About Us", "about")}</li>
              <li>{renderNavLink("Services", "services")}</li>
              <li>{renderNavLink("Contact", "contact")}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="text-gray-400 space-y-2">
              <p>Email: info@impactlogisticsservices.com</p>
              <p>Phone: 732 506 8608</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 border-solid mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400">
              © {currentYear} Impact Logistics. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link
                to="/terms"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Terms & Conditions
              </Link>
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
